import React from 'react';
import { PostTypes } from '../../../Utils/Types';

import PostsCreateMenu from './PostsCreateMenu';
import { PostTypeOrSurvey } from '../../../Utils/Types/Posts';

interface ConsultationsMenuProps {
  parentId?: string | number | null;
}

const types = [
  PostTypes.PARTICIPATORY_BUDGET,
  PostTypes.COLLABORATIVE_DECISION,
  PostTypes.IDEAS_REQUEST,
  'survey',
  PostTypes.STUDY,
] as PostTypeOrSurvey[];

function ConsultationsMenu({ parentId }: ConsultationsMenuProps) {
  return <PostsCreateMenu postTypes={types} parentId={parentId} />;
}

export default ConsultationsMenu;
